export default "__VITE_ASSET__BfFXS1ja__"